import React from 'react';
import { FlowerIcon } from 'lucide-react';
type DividerProps = {
  className?: string;
};
export function Divider({
  className = ''
}: DividerProps) {
  return <div className={`flex w-full items-center justify-center gap-4 py-6 ${className}`} aria-hidden="true" data-id="element-10" data-mp="1g9ffw59agfva">
      <span className="h-px w-16 sm:w-24 bg-dorado/50" data-id="element-11" data-mp="1q1bqgfsk9yge" />
      <FlowerIcon className="h-5 w-5 text-dorado" strokeWidth={1.5} data-id="element-12" data-mp="1q0tkgrg3k5va" />
      <span className="h-px w-16 sm:w-24 bg-dorado/50" data-id="element-13" data-mp="sew8lcw82ysb" />
    </div>;
}